import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'backgroundImage' })
export class BackgroundImagePipe implements PipeTransform {
  transform(images, dimensions) {
    if (images.length > 0) {
      return 'url(' + images[0].styles[dimensions] + ')'
    } else {
      return ''
    }
  }
}
